var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visibility
    ? _c("div", { staticClass: "pagination" }, [
        _c(
          "button",
          {
            staticClass: "prev",
            attrs: { disabled: _vm.currentPage === 1 },
            on: { click: _vm.prevPage },
          },
          [_c("span", { staticClass: "icon-arrow-left-grey icon" })]
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "page-list" },
          _vm._l(_vm.displayedPages, function (page) {
            return _c("li", { key: page }, [
              page === "..."
                ? _c("span", { staticClass: "ellipsis" }, [
                    _vm._v(_vm._s(page)),
                  ])
                : _c(
                    "span",
                    {
                      class: { active: _vm.currentPage === page },
                      on: {
                        click: function ($event) {
                          return _vm.gotoPage(page)
                        },
                      },
                    },
                    [_vm._v(_vm._s(page))]
                  ),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "next",
            attrs: { disabled: _vm.currentPage === _vm.totalPages },
            on: { click: _vm.nextPage },
          },
          [_c("span", { staticClass: "icon-arrow-right-grey icon" })]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }